// extracted by mini-css-extract-plugin
export default {"extendedIcon":"PhotoManager_extendedIcon__1DBji","btnItem":"PhotoManager_btnItem__e8Voa"};